import $ from 'jquery';
import { SOCKET_EVENTS } from '../../../socket/Socket';
import { areInSameScene } from '../../MVC/dataHelpers';
import { gsap } from 'gsap';
import { Back } from 'gsap/all';
import { NOTIFICATION_EVENTS } from '../../../constants/notifications';
import { hashString } from '../../../socket/socketHelper';
import { isMobile } from "../../engine/helpers/worldHelpers";

const trafficNotificationItem = (data, id, text, classType) => `           
<div class="info-notification ${classType}" id="notif-${id}">
  <div class="img-wrapper">
    <img src="${data.userAvatarUrl}" onError='this.src = "textures/defaultAvatar.png"'/>
  </div>
  <p>${text}</p>
</div>
`;

const notificationItem = (id, text, classType, icon = '') => `           
<div class="info-notification ${classType}" id="notif-${id}">
  ${icon}
  <p>${text}</p>
  <span class="material-icons close-notification">close</span>
</div>
`;

const notifications = {};
const notificationDictionary = {};
class InfoNotification {

  constructor({ model, socket }) {

    this.defaults = {
      createNotification: { text: '', showTime: 5000, classType: 'neutral', area: 'bottom left', autoRemove: true, withSound: false, song: 'message' }
    }

    this.model = model;
    this.socket = socket;
    this.counter = 0;
    this.socketUsers = socket ? socket.getUsersObject : {};

    this.eventsListener(this);

  }

  // EVENTS
  eventsListener(self) {
    $(document).on('click', '.info-notification', function () {
      const num = $(this).attr('id').replace('notif-', '');
      self.killNotification(num);
    });

    this.socket && this.socket.addEventListener(SOCKET_EVENTS.USER_JOINED_SCENE, (e) => {
      const users = this.socket.getUsers();
      const { senderId } = e.data;
      const user = this.socketUsers()[senderId];
      if (users.length === 2) {
        const socketMe = this.socketUsers()[this.socket.getUserData().userId];
        if (areInSameScene(user, socketMe, this.model.sceneData.scenes)) {
          this.createTrafficNotification({ user: e.data, text: `joins`, classType: 'info', type: 'traffic' });
          this.model.playAudioNotification('enter1');
        }
      }
    });

    this.socket && this.socket.addEventListener(SOCKET_EVENTS.USER_LEFT_SCENE, (e) => {
      // const { payload } = e;
      // const socketMe = this.socketUsers()[this.socket.getUserData().userId];
      // const user = this.socketUsers()[payload.senderId];
      // if (areInSameScene(user, socketMe, this.model.sceneData.scenes)) {
      //   this.createTrafficNotification({ user: payload, text: `left`, classType: 'error', type: 'traffic' });
      //   this.model.playAudioNotification('leave1');
      // }
    });

    this.model.addEventListener(NOTIFICATION_EVENTS.INFO, (e) => {
      if (this.model.publicStage) {
        this.createNotification({ ...this.defaults.createNotification, ...e.data, withSound: false });
      } else {
        this.createNotification({ ...this.defaults.createNotification, ...e.data });
      }
    });
    this.model.addEventListener(NOTIFICATION_EVENTS.REMOVE_ALL, (e) => {
      for (const key in notifications) {
        if (notifications.hasOwnProperty(key)) {
          this.killNotification(notifications[key]);
        }
      }
    });
  }

  // METHODS
  killNotification = (num) => {
    if (!notifications[num]) return;

    const { container } = notifications[num];
    let item = container.find(`#notif-${num}`);
    delete notifications[num];
    item.remove();
    item = null;
  }

  createTrafficNotification = ({ user, text, showTime = 200, classType = 'neutral', type = '', area = 'bottom left', autoRemove = true }) => {
    const num = this.counter;
    const data = this.socketUsers()[user.senderId];
    notificationDictionary[hashString(text)]
    if (type == 'traffic') {
      text = `${data.userName} ${text} ${data.currentSceneName}`;
    }

    const item = $(trafficNotificationItem(data, num, text, classType));
    const container = this.getContainer(area);
    container.append(item);
    notifications[num] = { item, container };

    this.counter++;

    this.playAnimation({ item, showTime, area, num, autoRemove });
  }

  createNotification = (data) => {
    const { text, showTime, classType, area, autoRemove, withSound, song, icon = '' } = data;
    // const num = this.counter;
    if (notifications[hashString(text)]) return;
    const num = hashString(text);
    const item = $(notificationItem(num, text, classType, icon));
    const container = this.getContainer(area);
    container.append(item);
    notifications[num] = { item, container };
    this.counter++;

    withSound && this.model.playAudioNotification(song);

    this.playAnimation({ item, showTime, area, num, autoRemove });
  }

  playAnimation({ item, showTime, area, num, autoRemove }) {

    // console.log('item',item);
    // console.log('item0',item[0]);
    // console.log('item0',item[0].offsetWidth);
    let padding = 0;
    if (window.innerWidth > 915) {
      padding = 24;
    }
    let itemWidth = item[0].offsetWidth + padding;

    let xIn, xOut, yIn, yOut;
    xIn = xOut = yIn = yOut = 0;
    let from = null

    switch (area) {
      case 'bottom right': xIn = '-100%'; xOut = '-100%'; break;
      case 'bottom center': yOut = '100%'; break;
      case 'bottom left': xIn = '0%'; from = { x: '-10%' }; break;

      case 'middle left': xIn = '0%'; from = { x: '-10%' }; break;
      case 'middle right': xIn = '-100%'; xOut = '-100%'; break;

      // case 'top right': xIn = '-100%'; xOut = '-100%'; break;
      case 'top right': xIn = '-' + itemWidth + 'px'; xOut = '-' + itemWidth + 'px'; break;
      case 'top center': yOut = '-100%'; break;
      case 'top left': xIn = '0%'; from = { x: '-10%' }; break;

      default: xIn = '-100%'; xOut = '-100%';
    }

    const durationIn = .4;
    const durationOut = .4;
    const durationImg = .25;

    const img = item.find("img")[0];

    const fromTo = (element, to, from = null) => {
      if (from) {
        gsap.fromTo(element, from, to)
      } else {
        gsap.to(element, to)
      }
    }

    img && fromTo(img, { rotationY: 360, duration: durationImg, delay: showTime / 1000 / 2 - durationImg / 2 });
    fromTo(item[0], { opacity: 1, x: xIn, y: yIn, duration: durationIn, ease: Back.easeOut }, from);

    if (autoRemove) {
      fromTo(item[0], { opacity: 0, x: xOut, y: yOut, duration: durationOut, delay: showTime / 1000 }, from);
      const removeAfter = (durationIn + durationOut) * 1000 + showTime;

      setTimeout(() => {
        this.killNotification(num);
      }, removeAfter);
    }
  }

  getContainer = (area) => {
    switch (area) {
      case 'bottom right': return $("#notifications_bottom_right");
      case 'bottom center': return $("#notifications_bottom_center");
      case 'bottom left': return $("#notifications_bottom_left");

      case 'middle left': return $("#notifications_middle_left");
      case 'middle right': return $("#notifications_middle_right");

      case 'top right': return $("#notifications_top_right");
      case 'top center': return $("#notifications_top_center");
      case 'top left': return $("#notifications_top_left");

      default: return $("#notifications_top_right");
    }
  }

}

export default InfoNotification;
